import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import enTranslation from "../../translations/en.json";
import deTranslation from "../../translations/de.json";

i18n
  .use(initReactI18next) // Bindet an React
  .init({
    resources: {
      de: {
        translation: deTranslation,
      },
      en: {
        translation: enTranslation,
      },

    },
    lng: "de", // Standardsprache
    fallbackLng: "en",
    interpolation: {
      escapeValue: false, // Keine Escapes nötig
    },
  });

export default i18n;
